module.exports = __webpack_public_path__ + "img/ic_fluent_arrow_reset_24_regular.7e012bd7.svg";